
import { NoData } from 'components/NoData';
import { Options } from 'components/Options/Options';
import { Pagination } from 'components/Pagination/Pagination';
import { Td } from 'components/Td/Td';
import { useState } from 'react';
import { PageFooter, Table, Th, Tr } from 'styling/GlobalStyles';
import { IGetAllActionableAttendanceReportsSingleResponse } from 'types/api/attendanceApi.interface';
import { IPaginatedResponse } from 'types/api/general.interface';
import { formatDateForDisplay, handlePagination } from 'utils/helpers';
import { ResolveModal } from './ResolveModal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { setConfirmModal } from 'features/global/globalSlice';
import { createSnapshot } from 'features/attendance/attendanceSlice';
import { ModalTypes } from 'types/global.interface';

export const ActionableReports = ({ reports, params, setParams }: { reports: IPaginatedResponse<IGetAllActionableAttendanceReportsSingleResponse>, params: any, setParams: React.Dispatch<React.SetStateAction<any>> }) => {

    const [modal, setModal] = useState({ open: false, id: null })
    const dispatch = useDispatch<AppDispatch>()

    const openModal = (id: number, type: 'snapshot' | 'resolve') => {
        if (type == 'resolve') {
            setModal({ open: true, id })
        } else {
            dispatch(
                setConfirmModal({
                    isOpen: true,
                    onSave: async () => {
                        await dispatch(createSnapshot(id))
                    },
                    setParams: {
                        type: ModalTypes.BeforeSabe,
                        f: setParams,
                    },
                    word: 'create snapshot of this report',
                }),
            )
        }
    }

    return <>
        {reports?.data.length ? <Table>
            <Th>
                <Td w='15%' >Date From</Td>
                <Td w='15%'>Date To</Td>
                <Td w='15%' >Aproval Status</Td>
                <Td w='15%' >Current User Assigned</Td>
                <Td w='15%' >Number of steps</Td>
                <Td w='20%' >Resolvable</Td>
                <Td w='5%' />
            </Th>
            {reports?.data.map((r, i) => <Tr key={i}>
                <Td w='15%'>{formatDateForDisplay(r.dateFrom)}</Td>
                <Td w='15%'>{formatDateForDisplay(r.dateTo)}</Td>
                <Td w='15%'>{reportStatuses[r.approvalStatus - 1]}</Td>
                <Td w='15%'>{r.currentSnapshot ? (r.currentSnapshot.user.firstName + ' ' + r.currentSnapshot.user.lastName) : 'N/A'}</Td>
                <Td w='15%'>{r.workflowSteps.length}</Td>
                <Td w='20%'>{r.canResolveWorkflowStep ? 'Yes' : 'No'}</Td>
                <Td w='5%' options >
                    <Options openModal={openModal} title='Attendance Reports' item={r} />
                </Td>
            </Tr>)}
        </Table> : <NoData />}
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(reports.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
        {modal.open && <ResolveModal id={modal.id} closeModal={() => setModal({ open: false, id: null })} />}

    </>

}

const reportStatuses = ['Pending', 'Approved', 'Rejected']